module.exports = __webpack_public_path__ + "img/身份验证前.09f4dd97.png";